import { Outlet, useLocation } from "react-router-dom"
import { usePageWrapper, usePermission } from "../../../hooks"
import { Box } from "@mui/material"
import { ArtTabs } from "@art/shared-ui"

const GeneralUsage = () => {

    const location = useLocation();
    const canViewUsage = usePermission("PLATFORM_SETTINGS", "BILLING_USAGE", "Usage");
    const canManageAlerts = usePermission("PLATFORM_SETTINGS", "BILLING_USAGE", "Alerts");

    return <div>
        <ArtTabs tabs={[
            ...(canViewUsage ? [{
                label: "Overview",
                route: "/platform-settings/usage/overview"
            }, {
                label: "Application limits",
                route: "/platform-settings/usage/limits"
            }, {
                label: "Platform limits",
                route: "/platform-settings/usage/platform-limits"
            }] : []),
            ...(canManageAlerts ? [{
                label: "Alerts",
                route: "/platform-settings/usage/alerts"
            }] : []),
        ]} 
        currentPath={location.pathname}
        />

        <Box sx={{ py: '30px' }}>
            <Outlet />
        </Box>

    </div>
}

export default usePageWrapper(GeneralUsage, {
    page_title: "Usage"
})
